export const chromeExtension = "lpbbgiejcehpljjbealmlaenekkldbgc"
export const productID = "com.cfca.cryptokit.cofco"

export const extensionName = productID + ".extension"
export const reqEventName  = productID + ".request"
export const respEventName = productID + ".response"

export const GenerateRandomId = ()=> {
  var charstring = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890'
  var maxPos = charstring.length
  var randomId = ''
  for (var i = 0; i < 10; i++) {
      randomId += charstring.charAt(Math.floor(Math.random() * maxPos))
  }
  return randomId
}


// WEBPACK FOOTER //
// ./apps/cfca/cryptokit/const/cryptokit.js